"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.KapiSwitch = void 0;
var react_1 = __importDefault(require("react"));
var config_1 = require("../../config");
/**
 * Conditionally render the passed "Kapi" or "Legacy" component depending on
 * kapi state in the configService.
 *
 */
function KapiSwitch(_a) {
    var Kapi = _a.Kapi, Legacy = _a.Legacy, kapiId = _a.kapiId, properties = _a.properties;
    var _b = config_1.configService.getConfig(), kapi = _b.kapi, region = _b.retailer.region;
    var isKapiEnabled = region === 'UK' ? kapi === null || kapi === void 0 ? void 0 : kapi[kapiId] : true;
    return (react_1.default.createElement("div", { "data-testid": "kapi-switch" }, isKapiEnabled ? (react_1.default.createElement("div", { "data-testid": "kapi-switch-kapi" },
        react_1.default.createElement(Kapi, __assign({}, properties)))) : (react_1.default.createElement("div", { "data-testid": "kapi-switch-legacy" },
        react_1.default.createElement(Legacy, __assign({}, properties))))));
}
exports.KapiSwitch = KapiSwitch;
